import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Subscriptions from './pages/Subscriptions';
import Accounts from './pages/Accounts';
import Renovaciones from './pages/Renovaciones';
import Catalog from './pages/Catalog';
import Reminders from './pages/Reminders';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import ProCenter from './pages/ProCenter';
import PremiumAgent from './pages/PremiumAgent';
import ClientPortal from './pages/ClientPortal';

const BLOCK_MSG = {
  trial_ended: { title: 'Tu prueba de 2 días terminó', body: 'El período de demostración finalizó. Para seguir usando StreamControl, contacta al administrador e inicia tu mensualidad.' },
  expired: { title: 'Tu mensualidad venció', body: 'Tu plan llegó a su fecha de vencimiento. Contacta al administrador para renovar y reactivar tu cuenta.' },
  suspended: { title: 'Tu cuenta está desactivada', body: 'Un administrador desactivó tu acceso. Contacta al administrador para reactivarla.' },
};

function Blocked({ user, onLogout }) {
  const m = BLOCK_MSG[user.blockReason] || BLOCK_MSG.expired;
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="card max-w-md space-y-4 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/15 text-2xl">⏳</div>
        <h1 className="text-xl font-bold">{m.title}</h1>
        <p className="text-sm text-slate-400">{m.body}</p>
        <button className="btn-ghost w-full" onClick={onLogout}>Cerrar sesión</button>
      </div>
    </div>
  );
}

export default function App() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (location.pathname.startsWith('/portal/')) {
    return <ErrorBoundary resetKey={location.pathname}><Routes><Route path="/portal/:token" element={<ClientPortal />} /></Routes></ErrorBoundary>;
  }

  // Panel de administración: login separado, fuera del auth de vendedores
  if (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) {
    return (
      <ErrorBoundary resetKey={location.pathname}>
        <Admin />
      </ErrorBoundary>
    );
  }

  if (loading)
    return <div className="flex h-screen items-center justify-center text-slate-400">Cargando…</div>;

  if (!user)
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );

  // Prueba o mensualidad vencida: se inhabilitan las funciones
  if (user.blocked) return <Blocked user={user} onLogout={logout} />;

  return (
    <Layout>
      <ErrorBoundary resetKey={location.pathname}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clientes" element={<Clients />} />
          <Route path="/suscripciones" element={<Subscriptions />} />
          <Route path="/banco" element={<Accounts />} />
          <Route path="/renovaciones" element={<Renovaciones />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/recordatorios" element={<Reminders />} />
          <Route path="/pro" element={<ProCenter />} />
          <Route path="/agente" element={<PremiumAgent />} />
          <Route path="/ajustes" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </ErrorBoundary>
    </Layout>
  );
}
